<div class="flex flex-column align-items-center justify-content-center h-screen p-1 gap-3">
  <div class="flex">
    <!-- <p-avatar *ngIf="logo()" [image]="logo()" [style]="{'width': '24px', 'height': '24px'}" shape="circle" size="normal"
              styleClass="bg-white m-1"></p-avatar> -->
    <img [src]="logo()" alt="image" class="h-2rem opacity-70">
  </div>
  <div class="flex">
    <span class="text-6xl text-600">{{title()}}</span>
  </div>
  <div class="flex flex-column w-12 sm:w-7 md:w-5 lg:w-3">
    <app-login-form></app-login-form>
    <div class="flex justify-content-between">
      <app-sign-up></app-sign-up>
      <app-forgot-password></app-forgot-password>
    </div>
  </div>
  <div class="flex justify-content-center w-12 sm:w-7 md:w-5 lg:w-3">
    <div class="text-xs font-light text-600">{{author()}}</div>
  </div>
</div>
<div class="absolute top-0 right-0">
  <div class="text-xs font-light text-600">vers.: {{version()}}</div>
</div>
